"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _actions = require("./actions");

var _AppActions = require("../actions/AppActions");

var _I18nOption = _interopRequireDefault(require("./I18nOption"));

var _I18nSetting = _interopRequireDefault(require("./I18nSetting"));

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  localeOptions: {},
  data: (0, _I18nSetting.default)(),
  staged: (0, _I18nSetting.default)()
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchI18nOptionsActionTypes.SUCCESS, function (state, action) {
  return state.set('localeOptions', state.get('localeOptions').withMutations(function (map) {
    action.payload.data.forEach(function (option) {
      map.set(option.language, (0, _I18nOption.default)(option));
    });
  }));
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchI18nSettingActionTypes.SUCCESS, function (state, action) {
  return state.merge({
    data: (0, _I18nSetting.default)(action.payload.data),
    staged: (0, _I18nSetting.default)(action.payload.data)
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.SaveI18nSettingActionTypes.SUCCESS, function (state, action) {
  return state.merge({
    data: (0, _I18nSetting.default)(action.payload.data),
    staged: (0, _I18nSetting.default)(action.payload.data)
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.I18nActionTypes.STAGE_LANGUAGE, function (state, action) {
  var locale = state.getIn(['staged', 'locale']);
  var language = action.payload.language;

  if (!state.getIn(['localeOptions', language, 'availableLocale']).includes(locale)) {
    locale = state.getIn(['localeOptions', language, 'defaultLocale']);
  }

  return state.mergeIn(['staged'], {
    language: language,
    locale: locale
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.I18nActionTypes.STAGE_LOCALE, function (state, action) {
  return state.setIn(['staged', 'locale'], action.payload.locale);
}), (0, _defineProperty2.default)(_handleActions, _AppActions.AppActionTypes.RESET_STAGED_CHANGES, function (state) {
  return state.set('staged', state.get('data'));
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;